import { AuthErrorType, useAnalyticsErrorPageTracker } from '@cp-shared-19/frontend-ui';
import { ErrorPage } from 'components/error-page';
import React from 'react';

export const getOidcErrorType = () => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('errorType') as AuthErrorType | null;
};

export const NotAuthorizedPage: React.FC = () => {
    useAnalyticsErrorPageTracker('unauthorizedError');

    return <ErrorPage type="unauthorized-error" />;
};
